import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

import authReducer from './authSlice';
import menuReducer from './menuSlice';
import versionReducer from './versionSlice';

const appReducer = combineReducers({
    auth: authReducer,
    menu_active: menuReducer,
    vers: versionReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        // storage.removeItem('persist:root')
        state = {};
    }
    return appReducer(state, action);
};

export default rootReducer;